export const NAKSHATRAS = [
  { id: "ashwini", name: "Ashwini (अश्विनी)" },
  { id: "bharani", name: "Bharani (भरणी)" },
  { id: "krittika", name: "Krittika (कृत्तिका)" },
  { id: "rohini", name: "Rohini (रोहिणी)" },
  { id: "mrigashira", name: "Mrigashira (मृगशिरा)" },
  { id: "ardra", name: "Ardra (आर्द्रा)" },
  { id: "punarvasu", name: "Punarvasu (पुनर्वसु)" },
  { id: "pushya", name: "Pushya (पुष्य)" },
  { id: "ashlesha", name: "Ashlesha (आश्लेषा)" },
  { id: "magha", name: "Magha (मघा)" },
  { id: "purva_phalguni", name: "Purva Phalguni (पूर्व फाल्गुनी)" },
  { id: "uttara_phalguni", name: "Uttara Phalguni (उत्तर फाल्गुनी)" },
  { id: "hasta", name: "Hasta (हस्त)" },
  { id: "chitra", name: "Chitra (चित्रा)" },
  { id: "swati", name: "Swati (स्वाति)" },
  { id: "vishakha", name: "Vishakha (विशाखा)" },
  { id: "anuradha", name: "Anuradha (अनुराधा)" },
  { id: "jyeshtha", name: "Jyeshtha (ज्येष्ठा)" },
  { id: "moola", name: "Moola (मूल)" },
  { id: "purva_ashadha", name: "Purva Ashadha (पूर्वाषाढ़ा)" },
  { id: "uttara_ashadha", name: "Uttara Ashadha (उत्तराषाढ़ा)" },
  { id: "shravana", name: "Shravana (श्रवण)" },
  { id: "dhanishta", name: "Dhanishta (धनिष्ठा)" },
  { id: "shatabhisha", name: "Shatabhisha (शतभिषा)" },
  { id: "purva_bhadrapada", name: "Purva Bhadrapada (पूर्व भाद्रपद)" },
  { id: "uttara_bhadrapada", name: "Uttara Bhadrapada (उत्तर भाद्रपद)" },
  { id: "revati", name: "Revati (रेवती)" },
];
